exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul {\n    list-style-type: none;\n    padding-left: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/transaction/transaction.component.css
// module id = ../../../../../src/app/transaction/transaction.component.css
// module chunks = main